import React, { Fragment, useState } from 'react';
import { arrayOf, object, shape, string } from 'prop-types';
import Filter from 'components/filter/component';
import Result from './result';

export const DataPeriodicReleaseArchiveFilter = ( props ) => {

    const getResults = ( currentYearValue ) => {

        const resultGroups = props.config.results.map( ( result ) => {

            const results = result.results.filter( ( items ) => {

                if ( currentYearValue.value === 'All' ) {

                    return true;

                }

                return items.attributes.year === currentYearValue.value;

            } );

            return {
                title: result.title,
                id: result.id,
                results: results,
            };

        } );

        return resultGroups;

    };

    const onFilterChange = ( selectedOption ) => {

        const result = getResults( selectedOption );

        setState( {
            currentYearValue: selectedOption,
            currentResult: result,
            page: 1,
        } );

    };

    const renderFilters = () => {

        return props.config.filters.map( ( filter ) => {

            return (
                <Filter
                    key={ filter.name }
                    filter={ filter }
                    labelId="filter-title"
                    onChange={ onFilterChange }
                    value={ state.currentYearValue }
                    customMaxHeight="165px"
                />
            );

        } );

    };

    const changePrevPage = ( e ) => {

        renderPagination( state.page, updatePageFromPagination );

        setState( ( localState ) => {

            return {
                ...localState,
                page: localState.page - 1,
            };

        } );

    };

    const changeNextPage = ( e ) => {

        setState( ( localState ) => {

            return {
                ...localState,
                page: localState.page + 1,
            };

        } );

    };

    const updatePageFromPagination = ( e ) => {

        e.persist();
        setState( ( localState ) => {

            return {
                ...localState,
                page: parseInt( e.target.innerHTML, 10 ),
            };

        } );

    };

    const renderPagination = ( page, updateFunc, divisor ) => {

        const totalPages = Math.ceil( state.currentResult[ 0 ].results.length / divisor );
        const maxDisplayedPagination = 5;
        const newPages = [];

        if ( totalPages > maxDisplayedPagination ) {

            // page will be 1 at the lowest, but once we move away from
            // page 3, we need to just subtract 2 from our page.
            // When we approach 2 pages away from the end of our data,
            // we need to subtract another page for each page closer we get.
            const lowEnd = state.page - 2 >= 1
                ? totalPages - state.page >= 2
                    ? state.page - 2
                    : state.page - 2 - ( 2 - totalPages % state.page )
                : 1;

            // once we hit page 3, we need to start moving the pagination buttons
            // over on each 'next' hit. Once we get less than 2 pages away from our
            // total pages, our high end should just be 4 away from the low end to
            // keep our range of 5 pages.
            const highEnd = state.page + 2 >= totalPages
                ? totalPages
                : lowEnd + 4;

            for ( let i = lowEnd; i <= highEnd; i += 1 ) {

                newPages.push( i );

            }

        }
        else if ( totalPages > 1 ) {

            for ( let i = 1; i <= totalPages; i += 1 ) {

                newPages.push( i );

            }

        }

        const paginationButtons = newPages.map( function ( i ) {

            return (
                <a
                    key={ `paginationkey${ i }` }
                    onClick={ updateFunc }
                    className={ [ page === i ? 'selected' : '', 'pagination-btn' ].join( ' ' ) }
                >
                    { i }
                </a>
            );

        } );

        return paginationButtons;

    };

    const renderResults = () => {

        const divisor = state.currentResult.length < 2 ? 20 : 12;

        return (
            <div className="data-periodic-release-archive-filter-wrapper-with-notes">
                <div className={ [ state.currentResult.length === 1
                    ? 'data-periodic-release-archive-filter-result-wrapper-fullwidth'
                    : '', 'data-periodic-release-archive-filter-result-wrapper' ].join( ' ' ) }
                >
                    {
                        state.currentResult.map( ( result ) => {

                            return (
                                <Result
                                    key={ result.id }
                                    { ...{
                                        prev: changePrevPage,
                                        next: changeNextPage,
                                        update: updatePageFromPagination,
                                        page: state.page,
                                        paginationButtons: renderPagination( state.page, updatePageFromPagination, divisor ),
                                        divisor: divisor,
                                        result: result,
                                        displayTitle: state.currentResult.length !== 1,
                                    } }
                                />
                            );

                        } )
                    }
                </div>
                { props.config.note && (
                    <div
                        className="data-periodic-release-archive-note"
                        dangerouslySetInnerHTML={ { __html: props.config.note } }
                    >
                    </div>
                ) }
            </div>

        );

    };

    const currentYearValue = {
        label: props.config.filters[ 0 ].facets[ 0 ].name,
        value: props.config.filters[ 0 ].facets[ 0 ].name,
    };
    const [ state, setState ] = useState( {
        currentResult: getResults( currentYearValue ),
        page: 1,
        currentYearValue,
    } );

    return (
        <Fragment>

            <div className="data-periodic-release-archive-filter-body-filter">
                <div className="data-periodic-release-archive-filter-main-section-title">
                    { state.currentResult.length === 1 ? <span dangerouslySetInnerHTML={ { __html: state.currentResult[ 0 ].title } }></span> : null }
                </div>
                <div className="data-periodic-release-archive-filter-area">
                    <p className="filter-title">Filter by:</p>

                    <div className="filter-section">
                        { renderFilters() }
                    </div>
                </div>
            </div>
            <hr className="data-periodic-release-archive-filter-body-separator"></hr>
            { renderResults() }

        </Fragment>

    );

};

const withSubscribe = ( props ) => {

    return (
        <DataPeriodicReleaseArchiveFilter
            config={ props.config.attributes.data }
        />
    );

};

DataPeriodicReleaseArchiveFilter.propTypes = {
    config: shape( {
        attributes: shape( {
            data: shape( {
                note: string,
                filters: arrayOf( shape( {
                    name: string.isRequired,
                    facets: arrayOf( shape( {
                        name: string.isRequired,
                        query: object.isRequired,
                    } ) ),
                } ) ).isRequired,
                results: arrayOf( shape( {
                    title: string.isRequired,
                    results: arrayOf( shape( {
                        attributes: {
                            title: string.isRequired,
                            year: string.isRequired,
                            list: arrayOf( shape( {
                                url: string.isRequired,
                                icon: shape( {
                                    src: string.isRequired,
                                    alt: string.isRequired,
                                    text: string.isRequired,
                                } ),
                            } ) ),
                        },
                    } ) ).isRequired,
                } ) ).isRequired,
            } ),
        } ),
    } ).isRequired,
};
export default withSubscribe;
